//  Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved.
import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ConfigurationService } from './configuration-service';
import { Partners } from '../types/partners';

export type Theme = 'light' | 'dark';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  private renderer: Renderer2;
  private _theme = new BehaviorSubject<Theme>('light');

  constructor(rendererFactory: RendererFactory2, private configuration: ConfigurationService) {
    this.renderer = rendererFactory.createRenderer(null, null);
    const partnerId = configuration.partnerId ?? Partners.Cigent;
    let theme: Theme;
    if (partnerId === Partners.Lenovo || partnerId === Partners.Kanguru) {
      theme = configuration.theme;
    } else {
      theme = ThemeService.getLocalStorageTheme();
    }
    this.setTheme(theme);
  }

  private static getLocalStorageTheme(): Theme {
    const localStorageTheme = localStorage.getItem('theme') ?? 'light';
    return localStorageTheme === 'dark' ? localStorageTheme : 'light';
  }

  public getTheme(): Observable<Theme> {
    return this._theme.asObservable();
  }

  public setTheme(theme: Theme) {
    localStorage.setItem('theme', theme);
    this._theme.next(theme);

    if (theme === 'dark' ||
      this.configuration.partnerId === Partners.Lenovo ||
      this.configuration.partnerId === Partners.Kanguru) {
      this.renderer.addClass(document.body, 'dark-theme');
    } else {
      this.renderer.removeClass(document.body, 'dark-theme');
    }

    this.setFavIcons();
  }

  public setFavIcons() {
    const iconAppleTouch: HTMLLinkElement = document.querySelector("#icon-apple-touch");
    const icon32x32: HTMLLinkElement = document.querySelector("#icon-32x32");
    const icon16x16: HTMLLinkElement = document.querySelector("#icon-16x16");
    const iconShortcut: HTMLLinkElement = document.querySelector("#icon-shortcut");
    if (this.configuration.partnerId === Partners.Lenovo) {
      this.renderer.setProperty(iconAppleTouch, "href", "/assets/lenovologo-small-red.png");
      this.renderer.setProperty(icon32x32, "href", "/assets/lenovo-32x32.png");
      this.renderer.setProperty(icon16x16, "href", "/assets/lenovo-16x16.png");
      this.renderer.setProperty(iconShortcut, "href", "/assets/lenovo.ico");
    } else if (this.configuration.partnerId === Partners.Kanguru) {
      this.renderer.setProperty(iconAppleTouch, "href", "/assets/kanguru-apple-touch-icon.png");
      this.renderer.setProperty(icon32x32, "href", "/assets/kanguru-32x32.png");
      this.renderer.setProperty(icon16x16, "href", "/assets/kanguru-16x16.png");
      this.renderer.setProperty(iconShortcut, "href", "/assets/kanguru.ico");
    } else if ( this.configuration.partnerId === Partners.VRS) {
      this.renderer.setProperty(iconAppleTouch, "href", "/assets/vrs_small.png");
      this.renderer.setProperty(icon32x32, "href", "/assets/vrs-32x32.png");
      this.renderer.setProperty(icon16x16, "href", "/assets/vrs-16x16.png");
      this.renderer.setProperty(iconShortcut, "href", "/assets/vrs.ico");
    }
  }

}
